export default {
  headerDetails: "Detalles del producto",
  "headerSign In": "Iniciar sesión",
  headerSettings: "Configuración",
  headertransaction: "Pedidos",
  signin: "Iniciar sesión",
  signinReq: "* Indica un campo obligatorio",
  emailReq:"Correo electrónico*",
  passwordReq:"Contraseña*",
  newTo: "¿Nuevo en CalmPurr?",
  createAccount: "Crear cuenta",
  firstName: "Nombre*",
  lastName: "Apellido*",
  streetaddress: "Dirección*",
  state: "Provincia*",
  city: "Ciudad*",
  zip: "Código postal*",
  phone: "Teléfono*",
  country: "País*",
  done: "Listo",
  categoryPopular: "Popular",
  categoryCustom: "Personalizado con foto",
  categoryFat: "Gato gordito",
  categorySlim: "Gato delgado",
  categoryMini: "Mini gato",
  freeShippingTips: "¡Envío gratuito a todo el mundo en todos los pedidos!",
  alreadyHaveAccount: "¿Ya tienes una cuenta?",
  code: "Código",
  bestseller: "Más vendidos",
  recommendforyou: "Recomendado para ti",
  ourcustomershow: "Fotos de clientes",
  faq: "Preguntas frecuentes",
  faq1: "¿Hacen envíos internacionales?",
  faq1answer: "¡Sí! Enviamos a más de 90 países. Para verificar la disponibilidad en tu zona, simplemente introduce tu dirección en la página de pago. Estamos ampliando constantemente nuestras opciones de envío internacional✈️",
  faq2: "¿Cuánto tarda el envío?",
  faq2answer: "Dependiendo de la región, el envío estándar tarda entre 6 y 10 días laborables. Los productos personalizados necesitan 3–7 días adicionales de producción. Recibirás un correo con el número de seguimiento cuando tu pedido sea enviado.💖",
  faq3:"¿Cómo rastreo mi pedido?",
  faq3answer: "Una vez enviado, encontrarás tu número de seguimiento y toda la información en la página de Detalles del Pedido, donde podrás ver el estado en tiempo real.",
  faq4:"¿De qué está hecho? ¿Es seguro?",
  faq4answer: "Nuestros squishies CalmPurr están hechos de silicona de grado alimenticio — suave, segura, no tóxica y muy agradable al tacto.",
  faq5:"¿Es resistente? ¿Se rompe fácil?",
  faq5answer: "Nuestros squishies son muy duraderos y pueden presionarse muchas veces. Recomendamos guardarlos en su empaque original para mantener su forma y calidad por más tiempo.",
  review1: "¡Lo amo muchísimo! El empaque también fue muy detallado. ¡Deseando colocarlo en un sitio especial!",
  review2: "Súper tierno y de excelente calidad. Viene con una bolsita muy linda 😍",
  review3: "Tardó un poco en llegar pero valió totalmente la pena. ¡Una réplica perfecta de un gato Bengalí, hermoso! 😍",
  review4: "No esperaba tanto pelo, pero honestamente no me importa porque ¡ES DEMASIADO TIERNO! Perfecto como juguete antiestrés.",
  review5: "Muy lindo y de gran calidad. No esperaba que fuera tan bueno.",
  review6: "Perdí a mi gatita en enero y pedí este squishy basado en su foto… realmente me ha ayudado.",
  review7: "Lo compré como regalo para mi amiga 💓 — llegó perfecto y valió totalmente la pena.",
  review8: "¡Amo mi gatito! El envío fue rápido y me encantó la cestita incluida. Creo que compraré otro pronto. ¡Gracias Bambi!",
  aboutus:"Sobre nosotros",
  contactus: "Contacto",
  privacypolicy: "Política de privacidad",
  terms: "Términos y condiciones",
  returnpolicy: "Política de devoluciones",
  footertitle: "Gatos de silicona hechos a mano",
  home: "Inicio",
  shoppingcart: "Carrito",
  orderhistory: "Historial de pedidos",
  settings: "Configuraciones",
  youshippinginfo: "Información de envío",
  shipping: "Envío",
  payment: "Pago",
  apply: "Aplicar",
  description: "Descripción",
  shippingInfo: "Información de envío",
  buyText: "Comprar",
  addtocart: "Añadido al carrito!",
  thankyou: "Gracias",
  yoursavings: "Tu ahorro",
  shippingInfoDetail: "Envío gratis. Entrega disponible a todo el mundo.",
  cartisempty: "Tu carrito está vacío",
  continueshopping: "Seguir comprando",
  itemtotal: "Subtotal",
  freeshipping: "Envío gratis",
  ordertotal: "Total",
  notorderyet: "Aún no has realizado ningún pedido.",
  shopnow: "Comprar ahora",
  changeemail: "Cambiar correo",
  changepass: "Cambiar contraseña",
  logout: "Cerrar sesión",
  changeemailtips: "Usa este formulario para cambiar tu correo electrónico.",
  currentemail: "Correo actual",
  newemail: "Nuevo correo",
  confirmemail: "Confirmar correo",
  enteremail: "Introducir correo",
  enterconfirmemail: "Confirmar nuevo correo",
  couponoff5title: "5% DE DESCUENTO",
  couponoff5desc: "Pedidos desde €50",
  couponoff10title: "10% DE DESCUENTO",
  couponoff10desc: "Pedidos desde €60",
  couponoff15title: "15% DE DESCUENTO",
  couponoff15desc: "Pedidos desde €80",
  contactemail: "Por favor ingresa tu correo*",
  contactsubject: "Asunto*",
  contactDesc: "Descripción*",
  areyousure: "¿Estás seguro?",
  cancelshipping: "¿Quieres cancelar la introducción de tu información de envío?",
  enterpromotioncode: "Introducir código promo",
  removeItemTips: "¿Eliminar este artículo del carrito?",
  removeItem: "Eliminar artículo",
  cancel: "Cancelar",
  placeorder: "Realizar pedido",
  currencyChangeTips: "Solo como referencia. El pago se procesará en Euro (€).",
  selectCurrency: "Seleccionar moneda",
  approx: "Aprox.",
  specialOffer: "Oferta especial",
  christmasOffer: "Especial de Año Nuevo 2026",
  christmasOfferCopy: "Haz clic en el código abajo para copiarlo",
  christmasOfferCondition: "Pedido superior a 50 €",
};



// WEBPACK FOOTER //
// ./src/lang/es.js